// extracted by mini-css-extract-plugin
export var container = "_6o-0";
export var error = "_6o-9";
export var label = "_6o-5";
export var light = "_6o-6";
export var md = "_6o-3";
export var sm = "_6o-2";
export var thin = "_6o-8";
export var thinBold = "_6o-7";
export var vertical = "_6o-4";
export var xs = "_6o-1";